/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IPaginatedList<T> {
        elements: Array<T>;
        page: IPage;
    }
    
    export interface IPage {
        size: number;
        totalElements: number;
        totalPages: number;
        number: number;
    }

    export class PaginatedList<T> implements IPaginatedList<T> {
        public elements: Array<T>;
        public page: IPage;

        constructor() {
            this.elements = [];
            this.page = new Page();
        }
    }

    export class Page implements IPage {
        public size: number;
        public totalElements: number;
        public totalPages: number;
        public number: number;

        constructor() {
            this.size = undefined;
            this.totalElements = undefined;
            this.totalElements = undefined;
            this.number = undefined;
        }
    }
}